import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { keycloak } from "../auth/keycloakService";
import ConfirmationDialogue from "./ConfirmationDialogue";

const LogoutHandler = () => {
  const navigate = useNavigate();
  const redirectUri = `${window.location.origin}`.trim();
  const [showConfirmation, setShowConfirmation] = useState(true);
  const [showLoader, setShowLoader] = useState(false);

  const handleLogout = () => {
    setShowLoader(true);
    keycloak.logout({ redirectUri });
  };

  useEffect(() => {
    if (!showConfirmation) {
      navigate(-1); // Go back if user cancels
    }
  }, [showConfirmation, navigate]);

  return (
    <>
      {showConfirmation && (
        <ConfirmationDialogue
          setShowConfirmation={setShowConfirmation}
          setShowLoader={setShowLoader}
          confirmSubmit={handleLogout}
          confirmationMessage="Are you sure you want to log out?"
        />
      )}
    </>
  );
};

export default LogoutHandler;
